<template>
  <article>
    <SimpleModal :title="message" @close="isShowModal=false" v-if="isShowModal"/>
    <router-view :key="key" />
  </article>
</template>

<script>
import SimpleModal from '@/components/modal/SimpleModal'

export default {
  components: { SimpleModal },
  data: function () {
    return {
      message: null,
      isShowModal: false
    }
  },
  created() {},
  mounted() {
    this.$events.$on('alert', function (eventData) {
      this.message = eventData.message
      this.isShowModal = true
    })
  },
  computed: {
    key() {
      if (this.$swal.isVisible() === true) {
        this.$swal.close()
      }
      return this.$route.fullPath
    }
  },
  methods: {
    openModal() {
      this.isShowModal = false
    }
  }
}
</script>
<style lang="scss" scoped>
  article {
    background: white;
    width: 100%;
    max-width: 680px;
    margin: 0 auto;
    position: relative;
    display: block;
    float: left;
  }
</style>
